import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class xeroService extends GenericService {
    constructor() {
        super('/xero', axiosInstance);
    }

    async getSettings() {
        try {
          const response = await axiosInstance.get(`${this.baseUrl}/settings`);
          return response.data;
        } catch (error) {
          throw this.handleError(error);
        }
    }

    async saveSettings(data) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/settings`, data);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getAuthorizeUrl() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/authorize`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getAccessToken(data) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/access-token`, data);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getTenants() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/tenants`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getAccounts() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/accounts`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getContactGroups() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/contact-groups`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new xeroService(); 